import { useHomeOutletContext } from "../../layout/useHomeOutletContext.ts";
import MiscellaneousHamburger from "../../../../common/icons/MiscellaneousHamburger.tsx";
import { useIntl } from "react-intl";
import { ComponentPropsWithoutRef } from "react";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";
import styles from "./Hamburger.module.scss";
import { HeaderTheme } from "./types.ts";

export default function Hamburger({
  theme,
  ...props
}: ComponentPropsWithoutRef<typeof BaseLinkOrButton> & { theme: HeaderTheme }) {
  const { isSidebarExpandable, onSidebarToggle } = useHomeOutletContext();
  const intl = useIntl();

  if (isSidebarExpandable) {
    return (
      <BaseLinkOrButton
        className={clsx(
          "vst-icon-button-square",
          "vst-icon-button-option-negative-margin",
          "vst-icon-button-option-compact",
          theme === "accent" && styles.accent,
          theme === "outline" && styles.outline,
          styles.button
        )}
        aria-label={intl.formatMessage({ defaultMessage: "Main Menu" })}
        data-tooltip-content={intl.formatMessage({
          defaultMessage: "Main Menu",
        })}
        onClick={onSidebarToggle}
        {...props}
      >
        <MiscellaneousHamburger />
      </BaseLinkOrButton>
    );
  }
}
